// extracted by mini-css-extract-plugin
export default {"addressSection":"SU-z","disabled":"TU-z","sectionButtons":"UU-z","logo":"VU-z"};